import { Box } from "@mui/material";

export default function ({ component: Component = Box, children, ...props }) {
  return <Component {...props}>{children}</Component>;
}
